import moment from "moment";

const formatDateNormal = (date: any, format = "DDMMYYYY") => {
  return moment(date).format(format);
};
export default formatDateNormal;
